export const RollbarSettings = {
  AccessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  Environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT
}
